module.exports = __webpack_public_path__ + "img/Linguetta_SX.2f446381.png";